import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { GiHamburgerMenu } from "react-icons/gi";

export const Navbar = () => {
    const navigate = useNavigate()
    const [menu, setMenu] = useState(false)
    return (
        <nav className='fixed flex px-[5vw] py-4 justify-between items-center w-full bg-[#dedadf] backdrop-blur-lg decoration-solid z-10'>
            {/* // This is the logo */}
            <h1 className='text-2xl font-bold'><Link to="/">N6T Technology</Link></h1>

            {/* // This is the navigation */}
            <ul className='flex space-x-5 max-md:hidden '>
                <li><Link to="/home">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to='/home#product'>Product</Link></li>
                <li><Link to="/contact">Contact</Link></li>
            </ul>

            {/* // This is the login button */}
            <button 
            onClick={() => window.location.href = "https://clinqo.in"} 
                className='bg-[#132893] px-7 py-2 text-white font-semibold rounded-xl max-md:hidden bg-gradient-to-br from-[#132893] to-[#2162DE]'
            >
            Login
            </button>

            {/* // This is the hamburger menu */}
            <button onClick={() => setMenu(!menu)} className='text-3xl text-black font-semibold rounded-xl md:hidden'>
                <GiHamburgerMenu />
            </button>

            {
                (menu) ? (
                    // This is the mobile menu
                    <div onClick={() => setMenu(!menu)} className="layer absolute top-0 left-0 w-[100vw] h-[100vh] md:hidden">
                        <ul className='fixed top-0 right-0 bg-[#d9d9d9]  flex flex-col justify-center items-center'>
                            <div className="heading bg-[#e8e7e8] py-2 flex items-center justify-around">
                                <button onClick={() => window.location.href = "https://clinqo.in"} className=' px-7 py-2 font-semibold italic text-blue-700'>
                                    Log In
                                </button>
                                <div className='rounded-full w-10 h-10 border-[2px] border-blue-600'>

                                </div>
                            </div>
                            <hr className='h-[2px] bg-white w-full' />
                            <li className='py-2'><Link to="/product">Product</Link></li>
                            <hr className='h-[2px] bg-white w-full' />
                            <li className='py-2'><Link to="/about">About Us</Link></li>
                            <hr className='h-[2px] bg-white w-full' />
                            <li className='py-2'><Link to="/contact">Contact Us</Link></li>
                        </ul>
                    </div>
                ) : (<></>)
            }
        </nav>
    )
}
